export default __webpack_public_path__ + "static/media/Shiny-Diamond.37a2c31a.png";